import { cents } from './money.js';
import type { Person, Receipt } from './types.js';

/**
 * The scenario from idea.md, as a fixture: a table of five, splitting alcohol
 * between two, meat among everyone except Kelly, and cigarettes onto Jason —
 * with one item nobody mentioned, so the clarification path gets exercised too.
 *
 * Used by the tests and by the app's simulator demo mode, so both exercise the
 * same numbers.
 */

export const DEMO_PEOPLE: Person[] = [
  { id: 'p1', name: 'Tudor' },
  { id: 'p2', name: 'Alex' },
  { id: 'p3', name: 'Kelly' },
  { id: 'p4', name: 'Jason' },
  { id: 'p5', name: 'Maria' },
];

export const DEMO_RECEIPT: Receipt = {
  currency: 'RON',
  merchant: 'Bodega Central',
  items: [
    { id: 'i1', name: 'Beer', qty: 2, unitPrice: cents(1250), lineTotal: cents(2500), category: 'alcohol' },
    { id: 'i2', name: 'House Wine', qty: 1, unitPrice: cents(3000), lineTotal: cents(3000), category: 'alcohol' },
    { id: 'i3', name: 'Grilled Ribs', qty: 1, unitPrice: cents(4500), lineTotal: cents(4500), category: 'meat' },
    { id: 'i4', name: 'Steak', qty: 2, unitPrice: cents(6000), lineTotal: cents(12000), category: 'meat' },
    { id: 'i5', name: 'Cigarettes', qty: 1, unitPrice: cents(2500), lineTotal: cents(2500), category: 'tobacco' },
    { id: 'i6', name: 'Coca-Cola', qty: 1, unitPrice: cents(900), lineTotal: cents(900), category: 'drink' },
  ],
  subtotal: cents(25_400),
  tax: cents(2_540),
  tip: cents(1_000),
  total: cents(28_940),
};
